import axios, { AxiosResponse } from 'axios';
import { apiClient } from '../../endpoints';
import { FormQuestionOption } from './formQuestionOptions';

export interface FormQuestion {
    _id: string;
    title?: string;
    sectionId: string;
    order: number;
    required: boolean;
    type: number;
    createdAt?: string;
    updatedAt?: string;
}

export interface FormQuestionWithOptions extends FormQuestion {
    options: FormQuestionOption[];
}

export interface FormQuestionsResponse {
    message: string;
    data: FormQuestion[];
}

export interface FormQuestionResponse {
    message: string;
    data: FormQuestion;
}

export interface CreateFormQuestionBody {
    sectionId: string;
    title?: string;
    type: number;
    required?: boolean;
    order?: number;
}

export interface UpdateFormQuestionBody {
    title?: string;
    type?: number;
    required?: boolean;
    order?: number;
}

export interface MoveFormQuestionBody {
    newSectionId?: string;
    newOrder?: number;
}

// CREATE
export const createFormQuestion = async (data: CreateFormQuestionBody): Promise<FormQuestionResponse> => {
    try {
        const response: AxiosResponse<FormQuestionResponse> = await apiClient.post('/form-questions', data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// DUPLICATE
export const duplicateFormQuestion = async (questionId: string): Promise<FormQuestionResponse> => {
    try {
        const response: AxiosResponse<FormQuestionResponse> = await apiClient.post(`/form-questions/${questionId}/duplicate`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// UPDATE
export const updateFormQuestion = async (questionId: string, data: UpdateFormQuestionBody): Promise<FormQuestionResponse> => {
    try {
        const response: AxiosResponse<FormQuestionResponse> = await apiClient.patch(`/form-questions/${questionId}`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// MOVE
export const moveFormQuestion = async (questionId: string, data: MoveFormQuestionBody): Promise<FormQuestionResponse> => {
    try {
        const response: AxiosResponse<FormQuestionResponse> = await apiClient.patch(`/form-questions/${questionId}/move`, data);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};

// DELETE
export const deleteFormQuestion = async (questionId: string): Promise<{ message: string }> => {
    try {
        const response: AxiosResponse<{ message: string }> = await apiClient.delete(`/form-questions/${questionId}`);
        return response.data;
    } catch (error) {
        if (axios.isAxiosError(error) && error.response) throw new Error(error.response.data.message);
        throw new Error('An unexpected error occurred');
    }
};
